import { makeStyles } from '@material-ui/styles';
import { MainButton } from '@bizzabo/design-system';

const ChatMessageDialogOneButtonFooter = ({ buttonText, onClick }) => {
    const classes = useStyles();
    return (
        <div className={classes.actions}>
            <MainButton onClick={onClick} variant={'fill'}>
                {buttonText}
            </MainButton>
        </div>
    );
};

const useStyles = makeStyles(
    () => ({
        actions: {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
        },
    }),
    { classNamePrefix: 'ChatMessageDialogOneButtonFooter' }
);

export default ChatMessageDialogOneButtonFooter;
